module.exports = __webpack_public_path__ + "static/gm-c8ec439adac97d51bd4162204803b154.png";